import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../../config';

class GiftRedeemHeader extends Component {
  getSubtitleText = () => (
    <p className="gift-header__subtitle">Enter your code to get started.</p>
  );

  getTitleText = () => {
    const { showLogin, hideSubtitle } = this.props;
    const { funnelConfig } = config;
    const baseText = 'Redeem Your Gift';
    if (funnelConfig) {
      const {
        redeemHeader,
      } = funnelConfig;
      if (!hideSubtitle) return redeemHeader || baseText;
    }
    if (!hideSubtitle) return baseText;
    const verbText = showLogin ? 'Sign in to' : 'Create an Account to';
    return `${verbText} ${baseText} `;
  }

  render() {
    const { hideSubtitle, children } = this.props;
    return (
      <div className="gift-redeem-header">
        <h4 className="gift-redeem-header__title">
          {this.getTitleText()}
        </h4>
        {hideSubtitle ? children : this.getSubtitleText()}
      </div>
    );
  }
}


GiftRedeemHeader.propTypes = {
  hideSubtitle: PropTypes.bool,
  showLogin: PropTypes.bool,
  children: PropTypes.node,
};

GiftRedeemHeader.defaultProps = {
  hideSubtitle: false,
  showLogin: false,
  children: null,
};

export default GiftRedeemHeader;
